import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function SuperAdminRoute({ children }) {
  const { profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F8F8]">
        <div className="text-gray-500 text-lg font-semibold">Loading...</div>
      </div>
    );
  }

  if (profile?.user_type !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
